import React from 'react';
import { Phone, Shield, Award, MessageSquare } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-r from-[#1B365D] to-[#2A4A7F] text-white overflow-hidden" data-id="element-246">
      {/* YouTube Video Background */}
      <div className="absolute inset-0 w-full h-full pointer-events-none" data-id="element-247">
        <div className="relative w-full h-full overflow-hidden" data-id="element-248">
          <iframe src="https://www.youtube.com/embed/QUJoggbQS80?autoplay=1&mute=1&controls=0&loop=1&playlist=QUJoggbQS80&showinfo=0&rel=0&disablekb=1&modestbranding=1&playsinline=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" className="absolute w-[300%] h-[300%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-30" style={{
          minWidth: '150%',
          minHeight: '150%'
        }} title="Crown Inspection Services Video" frameBorder="0" data-id="element-249"></iframe>
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B365D] to-[#2A4A7F] opacity-70" data-id="element-250"></div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-251">
        <div className="max-w-3xl" data-id="element-252">
          <div className="flex items-center mb-4" data-id="element-253">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ft96BQXpN2jabTTRnFyFuA/crowninspectionlogosmall.png" alt="Crown icon" className="w-8 h-8 mr-2" data-id="element-254" />
            <Shield className="text-[#D4AF37] mr-2" size={24} data-id="element-255" />
            <span className="text-[#D4AF37] font-semibold" data-id="element-256">
              Licensed & Insured Professional
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-257">
            Southwest Florida's Most Trusted Home Inspector
          </h1>
          <p className="text-xl md:text-2xl mb-6 text-gray-200" data-id="element-258">
            Protecting Your Investment with Thorough Inspections & Same-Day
            Reports Since 2008. Serving Fort Myers, Naples, Cape Coral & Beyond.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-259">
            <a href="tel:12396997080" className="flex items-center justify-center bg-white text-[#1B365D] py-3 px-6 rounded-md font-bold hover:bg-gray-100 transition-colors duration-200 shadow-md" data-id="element-260">
              <Phone size={20} className="mr-2" data-id="element-261" />
              Call 239-699-7080
            </a>
            <a href="sms:+12396997080?body=Hello, I'm interested in your inspections services." className="flex items-center justify-center bg-[#D4AF37] text-[#1B365D] py-3 px-6 rounded-md font-bold hover:bg-[#C09F2F] transition-colors duration-200 shadow-md" data-id="element-262">
              <MessageSquare size={20} className="mr-2" data-id="element-263" />
              Text Us
            </a>
          </div>
          <div className="flex flex-wrap gap-4 mb-8" data-id="element-264">
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-265">
              <Award size={16} className="mr-2 text-[#D4AF37]" data-id="element-266" />
              <span data-id="element-267">Licensed</span>
            </div>
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-268">
              <Shield size={16} className="mr-2 text-[#D4AF37]" data-id="element-269" />
              <span data-id="element-270">Insured</span>
            </div>
            <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-271">
              <Award size={16} className="mr-2 text-[#D4AF37]" data-id="element-272" />
              <span data-id="element-273">1000's of satisfied customers</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}